<template>
  <svg id="engraving" :x="0" :y="mouldingEngravingY" :width="`${mouldingEngravingWidth}`" :height="`${mouldingEngravingHeight}`" xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${mouldingEngravingWidth} ${mouldingEngravingHeight}`">
    <template v-for="line in lines">
      <text
        :font-size="line.fontSize"
        :letter-spacing="0.002"
        :font-family="line.fontStyle"
        :fill="textColor"
        :x="mouldingEngravingWidth / 2"
        :y="line.top + verticalAdjustment"
        text-anchor="middle"
      >
        {{ line.text }}
      </text>
    </template>
  </svg>
</template>

<script>
const fontSizes = {
  'Small Text': {
    'cheltenham': {
      line1: 10,
      line2: 10,
      line3: 10,
    },
    'apercu': {
      line1: 9,
      line2: 9,
      line3: 9,
    },
    'apercu-monospace': {
      line1: 7.5,
      line2: 7.5,
      line3: 7.5,
    }
  },
  'Monogram': {
    'cheltenham': {
      line1: 30,
    },
    'apercu': {
      line1: 30,
    },
  },
  'Title': {
    'cheltenham': {
      line1: 16.5,
      line2: 7,
    },
    'apercu': {
      line1: 14,
      line2: 7,
    },
    'apercu-monospace': {
      line1: 10,
      line2: 7,
    }
  },
  'Calligraphy': {
    'bickham-script-pro-3': {
      line1: 28,
    },
  }
};

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    mouldingEngraving: {
      type: Object,
      required: true
    },
    bottomMouldingY: {
      type: Number,
      required: true
    },
    mouldingEngravingWidth: {
      type: Number,
      required: true
    },
    mouldingEngravingHeight: {
      type: Number,
      required: true
    }
  },
  computed: {
    textColor() {
      return (this.frameSpec.moulding?.permalink || '').includes('silver')
        ? '#9c9c9c' : '#ffecbb';
    },
    lines() {
      const variantFontSizes = fontSizes[this.mouldingEngraving.layout][this.mouldingEngraving.fontStyle];
      const lines = [];

      let line1Top = (this.mouldingEngraving.layout === 'Title' ? -(variantFontSizes.line1 - 10) * 0.005 : 0);
      line1Top += this.pxToInches(variantFontSizes?.line1);

      const line1Height = this.mouldingEngraving?.line1 ? this.pxToInches(variantFontSizes.line1) : 0;
      lines.push({
        top: line1Top,
        height: line1Height,
        fontSize: this.pxToInches(variantFontSizes?.line1 || 0),
        fontStyle: this.mouldingEngraving.fontStyle,
        text: this.mouldingEngraving.line1
      });

      const line2Top = line1Top + line1Height - (this.mouldingEngraving.layout === 'Title' ? (variantFontSizes.line1 - 10) * 0.01 : 0);
      const line2Height = this.mouldingEngraving?.line2 ? this.pxToInches(variantFontSizes.line2) : 0;
      lines.push({
        top: line2Top,
        height: line2Height,
        fontSize: this.pxToInches(variantFontSizes?.line2 || 0),
        fontStyle: this.mouldingEngraving.layout === 'Title' ? 'apercu' : this.mouldingEngraving.fontStyle,
        text: this.mouldingEngraving.line2 || ''
      });

      const line3Top = line2Top + line2Height;
      const line3Height = this.mouldingEngraving?.line3 ? this.pxToInches(variantFontSizes.line3) : 0;
      lines.push({
        top: line3Top,
        height: line3Height,
        fontSize: this.pxToInches(variantFontSizes?.line3 || 0),
        fontStyle: this.mouldingEngraving.fontStyle,
        text: this.mouldingEngraving.line3 || ''
      });

      return lines;
    },
    linesHeight() {
      return this.lines.reduce((total, line) => total + line.height, 0);
    },
    mouldingEngravingY() {
      return this.bottomMouldingY;
    },
    verticalAdjustment () {
      let value = (this.mouldingEngravingHeight - this.linesHeight) / 2;

      if (this.mouldingEngraving.layout === 'Monogram') {
        value -= 0.05;
      }

      if (this.mouldingEngraving.layout === 'Calligraphy') {
        value -= 0.1;
      }

      return value;
    }
  },
  methods: {
    pxToInches (px) {
      // pixels per inch = 270px / 3.75in
      // this was calculated using the proportions from figma designs to match the font sizes
      const PPI = 72;

      return parseFloat(px) / PPI * 0.9;
    }
  }
};
</script>
